<template>
  <div :class="[$style.base, { [$style.smallScreen]: $screen === 's' }]">
    <Flex
      :direction="'column'"
      :gap="2"
    >
      <BaseHeading
        size="xl"
        center
      >
        {{ $t('reset_password.heading') }}
      </BaseHeading>
      <div v-if="!passwordResetSuccess">
        <BaseForm @submit="onSubmit">
          <Flex
            :direction="'column'"
            :gap="2"
          >
            <BaseInput
              v-model="password"
              :label="$t('global.password')"
              type="password"
              name="password"
              required
              newPassword
              v-test="'passwordInput'"
            />
            <BaseInput
              v-model="passwordConfirmation"
              :label="$t('global.password_confirmation')"
              type="password"
              name="passwordConfirmation"
              required
              :sameAs="password"
              v-test="'passwordConfirmationInput'"
            />
            <div :class="$style.bottom">
              <BaseButton
                submitForm
                v-test="'submit'"
              >
                {{ $t('global.actions.submit') }}
              </BaseButton>
            </div>
            <BaseText
              v-if="tokenExpiredError"
              center
              color="error"
            >
              {{ $t('reset_password.token_expired') }}
            </BaseText>
          </Flex>
        </BaseForm>
      </div>
      <Flex
        v-else
        :direction="'column'"
        :gap="2"
      >
        <BaseText
          center
          v-test="'emailSentInfo'"
        >
          {{ $t('reset_password.success_info') }}
        </BaseText>
        <div :class="$style.bottom">
          <BaseButton
            :routerLink="{ name: 'login' }"
            v-test="'backToLoginButton'"
          >
            {{ $t('forgot_password.back_to_login') }}
          </BaseButton>
        </div>
      </Flex>
    </Flex>
  </div>
</template>

<script lang="ts">
import useVuelidate from '@vuelidate/core';
import { defineComponent } from 'vue';
import axios from '@/axios';

export default defineComponent({
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      password: '',
      passwordConfirmation: '',
      token: '',
      tokenExpiredError: false,
      passwordResetSuccess: false,
    };
  },
  methods: {
    onSubmit() {
      this.v$.$touch();

      if (!this.v$.$invalid) {
        this.resetPassword();
      }
    },
    resetPassword() {
      axios
        .put('/passwords/reset_password', {
          reset_password_token: this.token,
          password: this.password,
          password_confirmation: this.passwordConfirmation,
        })
        .then(() => {
          this.passwordResetSuccess = true;
        })
        .catch(() => {
          this.tokenExpiredError = true;
        });
    },
  },
  created() {
    this.token = this.$route.query.token;
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  height: 100%;
}

.bottom {
  display: flex;
  justify-content: center;
}
</style>
